import React from 'react'
import * as ReactDOMServer from 'react-dom/server'

import ArrowLeftCircle from '@components/icons/ArrowLeftCircle'
import ArrowRightCircle from '@components/icons/ArrowRightCircle'

export type Config = {
    selector: string
    isMobile: boolean
    slideSelector: string
    arrowLeftCustomComponent?: string
    arrowRightCustomComponent?: string
    arrowLeftCustomAbsoluteStyle: {
        top?: string
        left?: string
        right?: string
        bottom?: string
    }
    arrowRightCustomAbsoluteStyle: {
        top?: string
        left?: string
        right?: string
        bottom?: string
    }
    revalidate?: string | number | boolean
}

export const defaultArrowLeft = ReactDOMServer.renderToString(
    React.createElement(ArrowLeftCircle)
)

export const defaultArrowRight = ReactDOMServer.renderToString(
    React.createElement(ArrowRightCircle)
)

export const defaultConfig: Config = {
    selector: '.custom-carousel',
    isMobile: false,
    slideSelector: '.slide',
    arrowLeftCustomComponent: defaultArrowLeft,
    arrowRightCustomComponent: defaultArrowRight,
    arrowLeftCustomAbsoluteStyle: {
        top: '50%'
    },
    arrowRightCustomAbsoluteStyle: {
        top: '50%'
    }
}

export const clickArrowRight = (
    container: HTMLElement,
    slide: HTMLElement
): void => {
    container.scrollLeft += slide.clientWidth
}

export const clickArrowLeft = (
    container: HTMLElement,
    slide: HTMLElement
): void => {
    container.scrollLeft -= slide.clientWidth
}

export const resetCarouselsArrows = (carousel: HTMLElement): void => {
    removeLeftArrow(carousel)
    removeRightArrow(carousel)
}

export const getCarouselLeftArrow = (
    hide: boolean,
    config: Config = defaultConfig
): HTMLDivElement => {
    const {
        arrowLeftCustomAbsoluteStyle,
        arrowLeftCustomComponent = defaultArrowLeft
    } = config

    const arrowLeftElement = document.createElement('div')

    arrowLeftElement.innerHTML = arrowLeftCustomComponent
    arrowLeftElement.classList.add(
        'carousel-arrow-left',
        'sticky',
        'w-min-content',
        'z-10'
    )
    arrowLeftElement.classList.toggle('hidden', hide)
    arrowLeftElement.style.top = arrowLeftCustomAbsoluteStyle.top || ''
    arrowLeftElement.style.bottom = arrowLeftCustomAbsoluteStyle.bottom || ''
    arrowLeftElement.style.left = arrowLeftCustomAbsoluteStyle.left || ''
    arrowLeftElement.style.right = arrowLeftCustomAbsoluteStyle.right || ''

    return arrowLeftElement
}

export const getCarouselRightArrow = (
    hide: boolean,
    config: Config = defaultConfig
): HTMLDivElement => {
    const {
        arrowRightCustomAbsoluteStyle,
        arrowRightCustomComponent = defaultArrowRight
    } = config

    const arrowRightElement = document.createElement('div')

    arrowRightElement.innerHTML = arrowRightCustomComponent
    arrowRightElement.classList.add(
        'carousel-arrow-right',
        'sticky',
        'w-min-content',
        'z-10'
    )
    arrowRightElement.classList.toggle('hidden', hide)
    arrowRightElement.style.top = arrowRightCustomAbsoluteStyle.top || ''
    arrowRightElement.style.bottom = arrowRightCustomAbsoluteStyle.bottom || ''
    arrowRightElement.style.left = arrowRightCustomAbsoluteStyle.left || ''
    arrowRightElement.style.right = arrowRightCustomAbsoluteStyle.right || ''

    return arrowRightElement
}

const removeLeftArrow = (parent: HTMLElement) =>
    parent?.querySelector('.carousel-arrow-right')?.remove()

const removeRightArrow = (parent: HTMLElement) =>
    parent?.querySelector('.carousel-arrow-left')?.remove()
